<script>
  import { Row, Col, Card, CardBody, CardTitle } from "sveltestrap";
  import { onMount } from "svelte";

  import ApexRadial from "./ApexRadial.svelte";

  let data = "";
  async function getData() {
    let location = "es-CL";
    location = await localStorage.getItem("LANGUAGE");
    if (location == "es") {
      location = "es-CL";
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://api.rastros.cl/api/home-screen?populate=%2A&locale=${location}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        data = result.data;
      })
      .catch((error) => console.log("error al contactar al servicio: ", error));
  }

  onMount(async () => {
    await getData();
  });
</script>

<Card style="height: 93%;">
  <CardBody>
    <CardTitle class="mb-4 h4 text-primary">{data.bytesLabel}</CardTitle>
    <Row>
      <Col sm="6">
        <p class="text-muted">{data.periodLabel}</p>
        <h3>$34,252</h3>
        <p class="text-muted">
          <span class="text-success me-2">
            {" "}
            12% <i class="mdi mdi-arrow-up" />{" "}
          </span>{" "}
          {data.secondPeriodLabel}
        </p>
      </Col>
      <Col sm="6">
        <div class="mt-4 mt-sm-0">
          <ApexRadial />
        </div>
      </Col>
    </Row>
    <p class="text-muted mb-0 padding-2">
      {data.resumeBytesLabel}
    </p>
  </CardBody>
</Card>

<style>
  .padding-2 {
    padding-bottom: 10px;
  }
</style>
